module.exports = __webpack_public_path__ + "427221acd8e46e853164dda2a4e449bc.svg";